import React, { useState, useEffect } from 'react'
import { canManageClients } from '../../global_context/capabilities/clientCapabilities'
import { ClientConsumer } from '../context/ClientContext'
import { GlobalConsumer } from '../context/GlobalContext'
import LoadingScreen from '../../components/LoadingScreen'

const ShowClientTab = (props) => {
  const [isClientEditing, setIsClientEditing] = useState(props.isClientEditing)
  const [isFetching, setIsFetching] = useState(false)

  const getFormattedDate = (date) => {
    return new Date(date).toLocaleString()
  }

  return (
    <div>
      {isFetching ? (
        <LoadingScreen text="Cargando..." />

      ) : (
        <ClientConsumer>
          {({
            clientData,
            failedCreation,
            failedCreationInfo,
            handleClickButton,
            handleSubmitEditClient,
            handleChange,
            clientEditDetailsData
          }) => (
            <GlobalConsumer>
              {({ handleEditingClient, globalEdit }) => (
                <div>
                  {!globalEdit ? (
                    <div>
                      <div className="show-product-header show-header">
                        <h2>Detalles del cliente:</h2>
                        <div>
                          {canManageClients() && (
                              <div className="show-buttons-responsive">
                                <input
                                  type="submit"
                                  onClick={(event) => {
                                    handleClickButton(event)
                                    handleEditingClient(event)
                                  }}
                                  value="Actualizar cliente"
                                />
                              </div>
                            )}
                        </div>
                      </div>
                      <div>
                        <hr />
                        <div className="">
                          <div>
                            {[
                              {
                                label: 'Nombre de cliente en sistema',
                                key: 'customer_name_db_ref'
                              },
                              { label: 'Código cliente', key: 'db_ref' },
                              {
                                label: 'Lista de Precio que le aplica',
                                key: 'price_list',
                                subKey: 'description'
                              },

                              {
                                label: 'Tipo de pago',
                                key: 'is_cash_client',
                                formatter: (val) =>
                                  val === true ? 'Contado' : val === false ? 'Crédito' : '-'
                              },
                              {
                                label: 'Activo',
                                key: 'active',
                                formatter: (val) => (val ? 'Si' : 'No')
                              },
                              { label: 'RUC', key: 'taxpayer_id' },
                              { label: 'DV', key: 'taxpayer_verificator_digit' },
                              { label: 'Razón social', key: 'business_name' },
                              { label: 'Nombre comercial', key: 'commercial_name' },
                              { label: 'Monto de crédito', key: 'credit_limit' },
                              { label: 'Representante legal', key: 'legal_representative' },
                              {
                                label: 'Persona de contacto para cobro',
                                key: 'billing_contact_name'
                              },
                              { label: 'Pago correo electrónico', key: 'billing_contact_email' },
                              { label: 'Pago teléfono', key: 'billing_contact_phone' },
                              { label: 'Persona de contacto', key: 'contact_name' },
                              { label: 'Correo electrónico', key: 'contact_email' },
                              { label: 'Teléfono', key: 'contact_phone' },
                              { label: 'Ciudad', key: 'city' },
                              { label: 'Calle', key: 'street' },
                              { label: 'Guía de ubicación', key: 'location_description' },
                              {
                                label: 'Longitud (grados decimales)',
                                key: 'geographical_longitud'
                              },
                              {
                                label: 'Latitud (grados decimales)',
                                key: 'geographical_latitude'
                              },
                              {
                                label: 'Creado',
                                key: 'created_at',
                                formatter: getFormattedDate
                              },
                              {
                                label: 'Actualizado',
                                key: 'updated_at',
                                formatter: getFormattedDate
                              }
                            ].map(({ label, key, subKey, formatter }) => (
                              <div className="show-data" key={key}>
                                <div className="mr-85">
                                  <b>{label}: </b>
                                </div>
                                <div className="text-details-clients">
                                  {formatter
                                    ? formatter(clientData[key])
                                    : subKey
                                      ? clientData[key] &&
                                        clientData[key][subKey] !== undefined &&
                                        clientData[key][subKey] !== null
                                        ? clientData[key][subKey]
                                        : '-'
                                      : clientData[key] !== undefined &&
                                        clientData[key] !== null &&
                                        clientData[key].length > 0
                                        ? clientData[key]
                                        : '-'}
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {failedCreation && (
                        <div className="show-product-header">
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="alert alert-danger" role="alert">
                                <p>{failedCreationInfo}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div>
                        <div className="inline-block full-width">
                          <form onSubmit={handleSubmitEditClient}>
                            <div className="show-product-header show-header">
                              <h2>
                                Actualizar detalles de cliente:{' '}
                                {`${clientData['db_ref']} - ${clientData['customer_name_db_ref']}`}
                              </h2>
                              <div className="show-buttons-responsive">
                                <input
                                  type="submit"
                                  onClick={handleEditingClient}
                                  className="cancel-edit-button"
                                  value="Cancelar"
                                />
                                <input type="submit" value="Actualizar" />
                              </div>
                            </div>
                            <hr />
                            <div>
                              {[
                                {
                                  label: 'Nombre de cliente en sistema',
                                  name: 'customer_name_db_ref',
                                  defaultValue: clientData['customer_name_db_ref'],
                                  type: 'text',
                                  required: true,
                                  placeholder: 'Nombre cliente en sistema'
                                },
                                {
                                  label: 'Código cliente',
                                  name: 'db_ref',
                                  defaultValue: clientData['db_ref'],
                                  disabled: true,
                                  type: 'text'
                                },
                                {
                                  label: 'Lista de Precio que le aplica',
                                  name: 'price_list_id',
                                  dataKey: 'price_list',
                                  editDataKey: 'price_list',
                                  descriptionKey: 'description',
                                  required: true
                                },
                                {
                                  label: 'Tipo de pago',
                                  name: 'payment_type_selection',
                                  type: 'select',
                                  options: [
                                    { value: 'contado', label: 'Contado' },
                                    { value: 'credito', label: 'Crédito' }
                                  ]
                                },
                                {
                                  label: 'Activo',
                                  name: 'active',
                                  options: [
                                    { value: true, label: 'Si' },
                                    { value: false, label: 'No' }
                                  ]
                                },
                                {
                                  label: 'RUC',
                                  name: 'taxpayer_id',
                                  defaultValue: clientData['taxpayer_id'],
                                  type: 'text',
                                  placeholder: '0000000-0-000000'
                                },
                                {
                                  label: 'DV',
                                  name: 'taxpayer_verificator_digit',
                                  defaultValue: clientData['taxpayer_verificator_digit'],
                                  type: 'text',
                                  placeholder: '00'
                                },
                                {
                                  label: 'Razón social',
                                  name: 'business_name',
                                  defaultValue: clientData['business_name'],
                                  type: 'text',
                                  placeholder: 'Razón Social'
                                },
                                {
                                  label: 'Nombre comercial',
                                  name: 'commercial_name',
                                  defaultValue: clientData['commercial_name'],
                                  type: 'text',
                                  placeholder: 'Nombre comercial'
                                },
                                {
                                  label: 'Monto de crédito',
                                  name: 'credit_limit',
                                  defaultValue: clientData['credit_limit'],
                                  type: 'number',
                                  step: '0.01',
                                  max: '999999',
                                  placeholder: '$$'
                                },
                                {
                                  label: 'Representante legal',
                                  name: 'legal_representative',
                                  defaultValue: clientData['legal_representative'],
                                  type: 'text',
                                  placeholder: 'Nombre representante legal'
                                },
                                {
                                  label: 'Persona de contacto para cobro',
                                  name: 'billing_contact_name',
                                  defaultValue: clientData['billing_contact_name'],
                                  type: 'text',
                                  placeholder: 'Nombre persona de contacto'
                                },
                                {
                                  label: 'Pago correo electrónico',
                                  name: 'billing_contact_email',
                                  defaultValue: clientData['billing_contact_email'],
                                  type: 'text',
                                  placeholder: 'Correo electrónico de pago'
                                },
                                {
                                  label: 'Pago teléfono',
                                  name: 'billing_contact_phone',
                                  defaultValue: clientData['billing_contact_phone'],
                                  type: 'text',
                                  placeholder: '0000-0000'
                                },
                                {
                                  label: 'Persona de contacto',
                                  name: 'contact_name',
                                  defaultValue: clientData['contact_name'],
                                  type: 'text',
                                  placeholder: 'Nombre persona de contacto'
                                },
                                {
                                  label: 'Correo electronico',
                                  name: 'contact_email',
                                  defaultValue: clientData['contact_email'],
                                  type: 'text',
                                  placeholder: 'Correo electrónico persona de contacto'
                                },
                                {
                                  label: 'Teléfono',
                                  name: 'contact_phone',
                                  defaultValue: clientData['contact_phone'],
                                  type: 'text',
                                  placeholder: '0000-0000'
                                },
                                {
                                  label: 'Ciudad',
                                  name: 'city',
                                  defaultValue: clientData['city'],
                                  type: 'text',
                                  placeholder: 'Ciudad'
                                },
                                {
                                  label: 'Calle',
                                  name: 'street',
                                  defaultValue: clientData['street'],
                                  type: 'text',
                                  placeholder: 'Calle'
                                },
                                {
                                  label: 'Guía de ubicación',
                                  name: 'location_description',
                                  defaultValue: clientData['location_description'],
                                  type: 'text',
                                  placeholder: 'Guía de Ubicación'
                                },
                                {
                                  label: 'Longitud (grados decimales)',
                                  name: 'geographical_longitud',
                                  defaultValue: clientData['geographical_longitud'],
                                  type: 'text',
                                  placeholder: '00.000000'
                                },
                                {
                                  label: 'Latitud (grados decimales)',
                                  name: 'geographical_latitude',
                                  defaultValue: clientData['geographical_latitude'],
                                  type: 'text',
                                  placeholder: '00.000000'
                                }
                              ].map(
                                ({
                                  label,
                                  name,
                                  dataKey,
                                  editDataKey,
                                  descriptionKey,
                                  defaultValue,
                                  disabled,
                                  type = 'select',
                                  options,
                                  required,
                                  placeholder
                                }) => (
                                  <>
                                    <div className="show-data" key={name}>
                                      <label
                                        htmlFor="inputName"
                                        className="col-sm-3 col-form-label"
                                      >
                                        {label}: {required && <span className="red">*</span>}
                                      </label>

                                      {type === 'select' ? (
                                        <select
                                          name={name}
                                          onChange={handleChange}
                                          defaultValue={
                                            name === 'payment_type_selection'
                                              ? clientData['is_cash_client']
                                                ? 'contado'
                                                : 'credito'
                                              : dataKey
                                                ? clientData[dataKey]?.id || ''
                                                : clientData[name] !== undefined
                                                  ? clientData[name]
                                                  : ''
                                          }
                                          className="form-control custom-select-clients client-form-input-width"
                                          disabled={
                                            editDataKey &&
                                            !clientEditDetailsData?.[editDataKey]?.length
                                          }
                                        >
                                          <option value="" disabled hidden>
                                            Escoja una opción
                                          </option>

                                          {clientEditDetailsData?.[editDataKey]?.map((obj) => (
                                            <option
                                              key={obj.id}
                                              value={obj.id}
                                              data-db_ref={obj.db_ref || obj.description || ''}
                                            >
                                              {obj[descriptionKey]}
                                            </option>
                                          ))}

                                          {options?.map((option) => (
                                            <option key={option.value} value={option.value}>
                                              {option.label}
                                            </option>
                                          ))}
                                        </select>
                                      ) : (
                                        <input
                                          type={type}
                                          name={name}
                                          onChange={handleChange}
                                          defaultValue={defaultValue}
                                          disabled={disabled}
                                          placeholder={placeholder}
                                          className="form-control client-form-input-width"
                                          style={{
                                            backgroundColor: disabled ? '#f0f0f0' : 'transparent'
                                          }}
                                        />
                                      )}
                                    </div>

                                    {label == 'Lista de Precio que le aplica' && (
                                      <div className="flex-direction-column">
                                        <div className="optional-separator">
                                          CAMPOS OPCIONALES:{' '}
                                        </div>
                                        <hr className="mt-0 mb-30 fullwidth" />
                                      </div>
                                    )}
                                  </>
                                )
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </GlobalConsumer>
          )}
        </ClientConsumer>
      )}
    </div>
  )
}

export default ShowClientTab
